<div class="nav-component">
  <mat-toolbar id="nav-component">
    <mat-toolbar-row>
      <div class="nav-component__row">
        <div class="nav-component__logo">
          <a href="https://www.phaenonet.ch/{{ lang() }}/" target="_blank">
            <img src="/assets/img/Bildmarke-Phaenonet_rgb.png" alt="PhaenoNet Logo" data-test-id="nav-logo"
          /></a>
        </div>
        <div class="nav-component__buttons">
          <button
            class="left-border"
            *ngIf="authenticated()"
            mat-button
            class="nav-component__button"
            [routerLink]="['profile']"
            data-test-id="nav-button-login"
          >
            {{ 'Profil' | translate }}
          </button>
          <button
            mat-button
            class="nav-component__button"
            [routerLink]="['auth/login']"
            data-test-id="nav-button-login"
            *ngIf="!authenticated()"
          >
            {{ 'Anmelden' | translate }}
          </button>
          <button mat-button class="nav-component__button" [routerLink]="['map']" data-test-id="nav-button-map">
            {{ 'Karte' | translate }}
          </button>
          <button
            mat-button
            class="nav-component__button"
            [routerLink]="['statistics']"
            data-test-id="nav-button-statistics"
          >
            {{ 'Auswertung' | translate }}
          </button>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</div>
